module.exports = __webpack_public_path__ + "img/building-user-menu.72c56bc5.svg";